// Loader.js
import React from 'react';
import '../styles/Loader.css';

const Loader = () => (
  <div className="loader-container">
    <div className="loader"></div>
  </div>
);

export default Loader;
